<template>
<div style="width:100%;position:relative;">

<div class="contact-images" :class="{expanded: contacts.length > 7}">
    <ImageFader :src="imageOne" class="contact-image white-border shadow " alt="" :style="contactOneStyle"/>
    <!-- <ImageFader :src="imageTwo" class="contact-image white-border shadow " alt="" :style="contactTwoStyle"/> -->
    <img :src="imageTwo" class="contact-image white-border shadow " alt="" :style="contactTwoStyle" />
    <img :src="imageThree" class="contact-image white-border shadow " alt="" :style="contactThreeStyle" />

    <div class="contact-label contact-label-1 " :class="{visible: this.contacts.length == 2 }">
        {{contactLabel(contacts[0])}}
    </div>
    <div class="contact-label contact-label-2" :class="{visible: this.contacts.length == 2 }">
        {{contactLabel(contacts[1])}}
    </div>
    <v-icon class="contact-heart" color="red lighten-2" :class="{hidden: !partners }">
        mdi-heart
    </v-icon>
    <div style="font-size:14px;" class="group-label" :class="{hidden:contacts.length < 3, lowered:contacts.length > 7}">{{selectedNames}} ({{contacts.length}})</div>

    <div v-if="contacts.length > 3" style="padding-left:11px;padding-top:2px;">
        <ImageGroup :images="limitedContacts.map(o => o.image)" />
    </div>
</div>
</div>

</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import StringHelpers from '../helpers/StringHelpers'
import ImageGroup from '../ui-elements/ImageGroup'
import ImageFader from '../ui-elements/ImageFader'

export default {
    data() {
        return {
        
        }
    },

    components: {
        ImageGroup,
        ImageFader,
    },
    
    props: {
        contacts: Array,
        partners: Boolean,
    },

    computed: {
        limitedContacts() {
            return this.contacts.slice(0, 14)
        },

        selectedNames() {
            let arr = [ ...this.limitedContacts.map(o => o.firstName) ]
            if(this.contacts.length > 14)
                arr.push('more...')
            return StringHelpers.sentenceJoin(arr)
        },
        imageOne() {
            if(this.contacts.length < 1)
                return ''

            return this.contacts[0].image
        },
        imageTwo() {
            if(this.contacts.length < 1)
                return ''
            if(this.contacts.length < 2)
                return this.contacts[0].image

            return this.contacts[1].image
        },
        imageThree() {
            if(this.contacts.length < 1)
                return ''
            if(this.contacts.length < 2)
                return this.contacts[0].image
            if(this.contacts.length < 3)
                return this.contacts[1].image

            return this.contacts[2].image
        },
        contactStyle() {
            const c = this.contacts.length
            let diameter = 50
            if(c < 2)
                diameter = 100
            else if(c < 3)
                diameter = 80

            let result = {}
            // result['position'] = (c <= 3 ? 'absolute' : 'static')
            result['width'] = diameter.toString() + 'px'
            result['height'] = diameter.toString() + 'px'
            return result
        },

        contactOneStyle() {
            const c = this.contacts.length
            let left = 77
            if(c > 2)
                left = 10
            if(c == 2)
                left = (this.partners ? 50 : 20)

            let result = {...this.contactStyle}
            result['left'] = left.toString() + 'px'
            result['opacity'] = ([1,2,3].includes(c) ? 1 : 0)

            if(this.partners)
                result['transform'] = 'rotate(20deg)'

            return result

        },

        contactTwoStyle() {
            const c = this.contacts.length
            let left = 50
            if(c < 2)
                left = 77
            else if(c < 3)
                left = (this.partners ? 120 : 150)

            let result = {...this.contactStyle}
            result['left'] = left.toString() + 'px'
            result['opacity'] = ([2,3].includes(c) ? 1 : 0)

            if(this.partners)
                result['transform'] = 'rotate(-20deg)'

            return result

        },

        contactThreeStyle() {
            const c = this.contacts.length
            let left = 85
            if(c < 3)
                left = 300

            let result = {...this.contactStyle}
            result['left'] = left.toString() + 'px'
            result['opacity'] = (c == 3 ? 1 : 0)

            return result

        },

        
    },

    methods: {
        contactLabel(contact) {
            if(!contact)
                return ''
            return ContactHelpers.fullName(contact)
        },

        // contactsArePartners() {
        //     if(this.contacts.length != 2)
        //         return false
        //     const c1 = this.contacts[0]
        //     const c2 = this.contacts[1]
        //     if(!c1 || !c2)
        //         return false
        //     return ContactHelpers.contactsArePartners(this.contacts[0], this.contacts[1])
        // },        
    },

    created() {

    }
}
</script>

<style scoped>

.contact-images {
    /* text-align:center; */
    position:relative;
    height:100px;
    width:280px;
    margin:0 auto;
}

.contact-images.expanded {
    height:150px;
}

.contact-image {
    width:50px;
    height:50px;
    display: inline-block;
    transition: all .6s ease-in-out;
    position: absolute;
}

.contact-label {
    text-align:center;
    opacity: 0;
    width:130px;
    height:20px;
    position: absolute;
    top:70px;
    /* width:0; */
    transition: all .4s ease-in-out;
    font-size:12px;

}

.contact-label.visible {
    opacity: 1;
    top:85px;
    /* width: 140px */
}

.contact-heart {
    opacity: 1;
    width:50px;
    height:50px;
    position: absolute;
    top:67px;
    transition: all .4s ease-in-out;  
    left:100px; 
}

.contact-heart.hidden {
    opacity: 0;
}

.contact-label-1 {
    left: -5;
}
.contact-label-2 {
    left: 125px;
}

.group-label {
    text-align:left;
    opacity: 1;
    width:270px;
    height:40px;
    position: absolute;
    top:60px;
    transition: all .4s ease-in-out;
    font-size:12px;  
    left:10px;  
}

.group-label.hidden {
    opacity: 0;
}

.group-label.lowered {
    top:100px;
}
   
</style>




// WEBPACK FOOTER //
// ContactImages.vue?158ad8a2